import React from "react";

import { Box, Modal, Container, Typography } from "@mui/material/";
import { TailSpin } from "react-loader-spinner";
import { PrimaryButton, SecondaryButton } from "../../../common/Buttons";
import { useTranslation } from "react-i18next";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1200,
  height: 600,
  bgcolor: "background.paper",
  borderRadius: "15px",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
  padding: "20px 20px",
};

const FilePreviewModal = ({
  data,
  fileName,
  handleClose = () => {},
  handleDelete = () => {},
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      keepMounted
      open={true}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Container maxWidth="lg">
        <Box sx={style}>
          <Box
            style={{
              display: "flex",
              width: "100%",
              marginBottom: "10px",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h5">{fileName}</Typography>
            <Box
              style={{
                display: "flex",
              }}
            >
              <SecondaryButton
                title={t("Cancel")}
                click={handleClose}
                fullWidth={false}
                padding="0.4rem 2rem"
                borderRadius={4}
                border="3px solid #c298bb"
                textTransform="none"
              />
              <PrimaryButton
                title={t("Delete")}
                click={handleDelete}
                fullWidth={false}
                borderRadius={4}
                padding="0.4rem 2rem"
                textTransform="none"
                margin="0 0 0 10px"
              />
            </Box>
          </Box>
          {data ? (
            <object
              data={data}
              style={{ height: "90%", width: "100%", objectFit: "contain" }}
            />
          ) : (
            <TailSpin color="#000000" height={30} width={60} />
          )}
        </Box>
      </Container>
    </Modal>
  );
};

export default FilePreviewModal;
